import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable new-cap */
/* eslint-disable no-unused-vars */
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { DndContext, closestCenter, KeyboardSensor, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, sortableKeyboardCoordinates, rectSortingStrategy } from '@dnd-kit/sortable';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import TableSettingsListItem from './TableSettingsListItem';
export var TableSettingsListContainer = function TableSettingsListContainer(props) {
  var items = props.items,
    onSortEnd = props.onSortEnd,
    itemProps = props.itemProps;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    activeDraggedColumn = _useState2[0],
    setActiveDraggedColumn = _useState2[1];
  var sensors = useSensors(useSensor(PointerSensor), useSensor(KeyboardSensor, {
    coordinateGetter: sortableKeyboardCoordinates
  }));
  var handleDragStart = useCallback(function (event) {
    setActiveDraggedColumn(event.active.id);
  }, []);
  var handleDragEnd = useCallback(function (event) {
    setActiveDraggedColumn(null);
    onSortEnd(event);
  }, []);
  var activeClass = 'table-settings-item shadow-smooth-to-bottom z-index-max';
  return /*#__PURE__*/React.createElement("div", {
    className: "table-settings-items-container"
  }, /*#__PURE__*/React.createElement(DndContext, {
    modifiers: [restrictToVerticalAxis],
    onDragStart: handleDragStart,
    onDragEnd: handleDragEnd
  }, /*#__PURE__*/React.createElement(SortableContext, {
    items: items,
    sensors: sensors,
    collisionDetection: closestCenter,
    strategy: rectSortingStrategy
  }, items.map(function (column, index) {
    return /*#__PURE__*/React.createElement(TableSettingsListItem, _extends({
      key: column,
      index: index,
      column: column,
      orderIndex: index,
      className: activeDraggedColumn === column ? activeClass : ''
    }, itemProps));
  }))));
};
TableSettingsListContainer.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string),
  onSortEnd: PropTypes.func,
  itemProps: PropTypes.object
};